import {
  Chip,
  List,
  ListItem,
  Paper,
  Typography,
  styled,
} from '@material-ui/core';

export const DropdownPaper = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  zIndex: 1300,
  maxHeight: 420,
  overflow: 'auto',
  marginTop: 4,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 8,
  boxShadow: theme.shadows[4],
}));

export const DropdownList = styled(List)({
  padding: 0,
});

export const DropdownListItem = styled(ListItem)(({ theme }) => ({
  paddingTop: 8,
  paddingBottom: 8,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const ResultTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: 14,
});

export const ResultContext = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  marginTop: 2,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical' as const,
  overflow: 'hidden',
}));

export const TabChip = styled(Chip)(({ theme }) => ({
  marginLeft: 0,
  height: 20,
  fontSize: 10,
  fontWeight: 700,
  color: theme.palette.common.white,
  textTransform: 'capitalize',
}));

export const HighlightSpan = styled('span')({
  backgroundColor: '#FFF3CD',
  fontWeight: 700,
  borderRadius: 2,
  padding: '0 1px',
});

export const EmptyMessage = styled('div')(({ theme }) => ({
  padding: '16px 20px',
  textAlign: 'center' as const,
  color: theme.palette.text.secondary,
  fontSize: 13,
}));
